<nav class="navbar">
  <div class="logo">
    <img [src]="src" alt="Company Logo" (error)="src = originalSrc" />
  </div>

  <div class="nav-actions" *ngIf="isLoggedIn">
    <button
      mat-button
      class="documents-btn"
      (click)="navigate()"
      *ngIf="hasDocsPermission"
    >
      Ir para {{ isDocsPage ? "Chatbot" : "Documentos" }}
    </button>

    <span class="user-name">{{ userName }}</span>
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>account_circle</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button
        mat-menu-item
        (click)="handleUsers()"
        *ngIf="hasHandleUsersPermission"
      >
        Gerenciar usuários
      </button>
      <button mat-menu-item (click)="logout()">Logout</button>
    </mat-menu>
    <button
      mat-icon-button
      matTooltip="Entrar em contato com o suporte"
      (click)="callSupport()"
    >
      <mat-icon>headset_mic</mat-icon>
    </button>
  </div>
</nav>
